export const addUniqueObjectToArray = (
    list: any[],
    el: any,
    property: any = undefined,
    value: any = undefined
): any[] => {
    let getFn: (item: any) => any = (item) => item;
    if (property) {
        getFn = (item) => item[property];
    }

    const target = value ?? getFn(el);
    const exists = list.some(item => getFn(item) === target);
    return exists ? list : [...list, el];
}
